module.exports = __webpack_public_path__ + "img/w3_circle_trash_delete_black.f60f0942.png";